<a href="explore/{{this.xploreItem.id}}">
  <div
    class="rounded-xl lg:rounded-3xl flex items-end aspect-[9/16] w-full max-w-[162px] sm:max-w-[241px] md:max-w-[177px] lg:max-w-full relative overflow-hidden">

    <img [src]="getImage()" class="absolute inset-0 h-full w-full object-cover" alt="Xplore Placeholder">
    <div
      class="py-[1rem] px-[0.5rem] md:py-6 md:px-4 xl:py-12 xl:px-6 bg-gradient-to-b from-transparent to-black rounded-b-xl lg:rounded-b-3xl relative z-10 w-full">
      <div class="mb-[0.5rem] lg:mb-[1rem] w-full">
        <h2 class="text-white font-semibold text-sm sm:text-base lg:text-xl 2xl:text-2xl line-clamp-2">
        {{xploreItem.name}}</h2>
      </div>

      @if (xploreItem.geoPosition?.comune) {
        <div>
          <p class="text-white text-xs sm:text-sm lg:text-base line-clamp-1">{{xploreItem.geoPosition.comune.name}}</p>
        </div>
      }

    </div>
  </div>
</a>
